import React, { useState, useEffect } from "react";
import { FaUsers } from "react-icons/fa";
import { SiTether } from "react-icons/si";
import MetaMask from "../assets/meta-mask.png"
import ConfirmJoinModal from "./ConfirmJoinModal";
import TermsModal from "../components/TermsModal";

const JoinRLSStakingProgram = ({ Joining, isJoined }) => {

  const [sponsor, setSponsor] = useState("");

  const [isSponsorLocked, setIsSponsorLocked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [status, setStatus] = useState({
     type: "ready", // ready | loading | success | error
     title: "Confirm Joining",
     message: "Please confirm your sponsor address."
   });
  const [showTermsFirst, setShowTermsFirst] = useState(false);

  // 🔹 On page load, check for query string (ref)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      setSponsor(ref);
      setIsSponsorLocked(true);
    }
  }, []);

  // -------------------------------
  // Open Modal
  // -------------------------------
  const handleJoinClick = () => {
    if (!sponsor);

    // ----------- CHECK SPONSOR FIRST -----------
    const refferedby = sponsor?.trim();
    if (!refferedby) {
      setStatus({
        type: "error",
        title: "Sponsor Missing",
        message: "Please enter sponsor address."
      });
      setShowModal(true);
      return; // stop here
    }

    setShowTermsFirst(true);

    setStatus({
      type: "ready",
      title: "Confirm Joining",
      message: "Please confirm your details."
    });

    setShowModal(true);
  };

  // -------------------------------
  // Confirm Join Inside Modal
  // -------------------------------
  const handleConfirmJoin = async () => {
    setStatus({
      type: "loading",
      title: "Joining…",
      message: "Please Confirm in Wallet."
    });

    try {
      await Joining(sponsor,setStatus);

      // setStatus({
      //   type: "success",
      //   title: "Success!",
      //   message: "You have successfully joined IBullz community."
      // });

    } catch (err) {
      console.error("Join Error:", err);

      setStatus({
        type: "error",
        title: "Failed!",
        message: err?.message || "Something went wrong."
      });
    }
  };

  // 🔹 ADD TOKEN TO METAMASK (opBNB Testnet)
  const addTokenToMetaMask = async () => {
    const tokenAddress = "0x9d07dAC32d7c835E9daA1802Ced37e5Fc5F9F2aD"; // ⭐ आपका token address
    const tokenSymbol = "BUSDT";
    const tokenDecimals = 18;
    const tokenImage = "https://bscscan.com/token/images/busdt_32.png"; // ⭐ public folder में रखें

    try {
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            image: tokenImage,
          },
        },
      });

      if (wasAdded) {
        alert("Token added successfully!");
      } else {
        alert("Token adding rejected.");
      }
    } catch (error) {
      console.error("MetaMask Error:", error);
      alert("MetaMask error: check console.");
    }
  };


  return (
    <>

        <TermsModal
  open={showTermsFirst}
  onClose={() => setShowTermsFirst(false)}
  onAccept={() => {
    setShowTermsFirst(false);
    setShowModal(true); // 👈 Ab original confirm modal open
  }}
/>
      {/* JOIN MODAL */}
      <ConfirmJoinModal
        open={showModal}
        sponsor={sponsor}
        status={status}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmJoin}
      />
      {!isJoined && (
        <div className="comunity-div">
          <div className="row">
            <div className="col-md-12">

              <div className="new_joining card-comunity cm-1">
                <div className="card-inner-div">
                  <div className="referral_row">
                    <div className="row w-referral_row align-items-end">
                      <div className="col-md-8">
                        <div className="referral-col">
                          <img src="referral-pic.svg" className="referral-pic-svg" />

                          <div className="referral-input">
                            <div className="section-title">
                              <h2 className="">  <span>Join iBullz  Community Today !</span> </h2>
                            </div>

                            <div className="input-group bonus_input">
                              <span className="input-group-text">
                                <FaUsers />
                              </span>
                              <input
                                type="text"
                                placeholder="Sponsor Address"
                                value={sponsor}
                                onChange={(e) => setSponsor(e.target.value)}
                                className="form-control"
                                readOnly={isSponsorLocked}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="col-md-4">
                        {/* ⭐ Add Token to MetaMask Button */}
                        <div className="MetaMaskdiv">

                      <button className="new_joining_btn" onClick={handleJoinClick}>
                            Join Now
                          </button>

                          <div className="metamask-row">
                            {/* <button
                              onClick={addTokenToMetaMask}
                              className="btn btn-success d-flex align-items-center gap-2"
                            >
                              <SiTether size={22} />
                              Import USDT

                          <img src={MetaMask} alt="" className="metamsk-image" />
                            </button> */}

                          {/* <button className="btn btn-primary" onClick={() =>
                            window.open(
                              "https://opbnb-testnet.bscscan.com/address/0x48E5D374694e2F88973C694F06c5d62ab76809Ff",
                              "_blank",
                              "noopener noreferrer"
                            )
                          }>
                            NFT Contract
                          </button> */}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}
    </>
  );
};

export default JoinRLSStakingProgram;
